/**
 * @generated SignedSource<<f7a5ee2123f7b1594840a52c5d93f3c3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StakingOverviewInput = {
  assetIds?: ReadonlyArray<string> | null | undefined;
  endDate?: DateScalar | null | undefined;
  startDate?: DateScalar | null | undefined;
};
export type StakingOverviewQuery$variables = {
  input?: StakingOverviewInput | null | undefined;
};
export type StakingOverviewQuery$data = {
  readonly stakingOverview: {
    readonly items: ReadonlyArray<{
      readonly asset: {
        readonly id: string;
        readonly logoUrl: string | null | undefined;
        readonly name: string | null | undefined;
        readonly symbol: string | null | undefined;
      };
      readonly rewardsAsset: PrecisionFloat;
      readonly rewardsFiat: PrecisionFloat;
      readonly stakedAsset: PrecisionFloat;
      readonly stakedFiat: PrecisionFloat;
    }> | null | undefined;
    readonly totalRewardsFiat: PrecisionFloat | null | undefined;
    readonly totalStakedFiat: PrecisionFloat | null | undefined;
  } | null | undefined;
};
export type StakingOverviewQuery = {
  response: StakingOverviewQuery$data;
  variables: StakingOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalStakedFiat",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRewardsFiat",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsAsset",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsFiat",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedFiat",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stakedAsset",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StakingOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StakingOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StakingOverview",
        "kind": "LinkedField",
        "name": "stakingOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "10047c6eebba801d34f457aeee56201b",
    "id": null,
    "metadata": {},
    "name": "StakingOverviewQuery",
    "operationKind": "query",
    "text": "query StakingOverviewQuery(\n  $input: StakingOverviewInput\n) {\n  stakingOverview(input: $input) {\n    totalStakedFiat\n    totalRewardsFiat\n    items {\n      asset {\n        __typename\n        id\n        name\n        symbol\n        logoUrl\n      }\n      rewardsAsset\n      rewardsFiat\n      stakedFiat\n      stakedAsset\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fae434fa639b6a8279062f938521d81f";

export default node;
